import { Box } from '@mui/material'

const LabelValuePair = ({
  value,
  label,
  column = false,
}: {
  value: number | string
  label: string | React.ReactNode
  column?: boolean
}) => {
  return (
    <Box
      fontSize="14px"
      letterSpacing="0.5px"
      lineHeight="normal"
      gap={label ? 1 : 0}
      display="flex"
      flexDirection={column ? 'column' : 'row'}
    >
      <Box display="flex" alignItems="center">
        {label}
      </Box>
      <Box
        bgcolor="rgba(33, 33, 33, 0.80)"
        fontSize="12px"
        lineHeight="20px"
        letterSpacing="0.25"
        px="6px"
        py="2px"
        borderRadius="4px"
        width="fit-content"
        whiteSpace="nowrap"
      >
        {value}
      </Box>
    </Box>
  )
}

export default LabelValuePair
